import React from 'react';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { map, head, get, isEmpty, isUndefined, find } from 'lodash';
import classNames from 'classnames';

// local dependencies
import { button as Button } from 'modules/button';
import {  AddEditAllergies  } from 'ui/containers/AddEditAllergies';

import { checkbox as CheckBox } from 'ui/views/generic/checkbox';
import { getLabel } from 'utils/getLabel';

// import { AddEditHealthConditions } from 'ui/containers/AddEditHealthConditions';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { epostAllergiesAndHealthConditions as EpostAllergiesAndHealthConditions } from 'ui/views/widgets/epostAllergiesAndHealthConditions';
 *
 * // render
 * <EpostAllergiesAndHealthConditions propName='propValue'/>
 */
const _epostAllergiesAndHealthConditions = ( props ) => {

    // get the value for allergies section
    const searchAndAddAllergies = {
        title: get( props, 'sections.allergies.title', {} ),
        fields: get( props, 'sections.allergies.common.fields', {} ),
    };
    const allergiesNoDataConfig = find( props.sections.allergies, { name: 'noData' }, {} );

    const searchAndAddHealthConditions = {
        title: get( props, 'sections.healthConditions.title', {} ),
        fields: get( props, 'sections.healthConditions.common.fields', {} ),
    };
    const healthNoDataConfig = find( props.sections.healthConditions, { name: 'noData' }, {} );
    const { noDataConfig, className, isNoDataSelected = false } = props;

    return (
        <div className='ui-epost-allergies-and-health-conditions'>
                 {<div className= 'ui-alergycheckbox'>
   
                    { ! isUndefined( noDataConfig ) && !isEmpty( noDataConfig ) && (

                    <NoDataView
                        { ...noDataConfig }
                        onNoDataSelection= { props.onNoDataSelection }
                        isNoDataSelected={ isNoDataSelected }
                    />


                    ) }
                    { ! isUndefined( noDataConfig ) && !isEmpty( noDataConfig ) && (

                    <NoDataView
                        { ...noDataConfig }
                        onNoDataSelection= { props.onNoDataSelection }
                        isNoDataSelected={ isNoDataSelected }
                    />


                    ) }

                    </div> }

            <div className='ui-epost-allergies-and-health-conditions__allergies'>

                {/* allergies section */}
                <AddEditAllergies
                    items={ props.allergies }
                    addEditMemberHealthConfig={ searchAndAddAllergies }
                    notePlaceHolder ={   head( get( props, 'sections.allergies.others.fields', [] ) )[ 'placeholder' ] }
                    titleClassName = { 'ui-epost-allergies-and-health-conditions__allergies__title' }
                    className={ 'ui-epost-allergies-and-health-conditions__allergies__section' }
                    showTitleIcon={ true }
                    noDataConfig = { allergiesNoDataConfig }
                    onUpdate={ props.onAllergiesUpdate }
                    selectionCriteria={ 'name' }
                    finalProp= { props }
                    allergiesVisibility = {props.visibility}
                    titlehealth= { 'AllergiesCondition' }
                    
                />

            </div>

            <div className='ui-epost-allergies-and-health-conditions__health ui-ehealth'>

                {/* health condition section */}
                {/* <AddEditHealthConditions */}
                <AddEditAllergies
                    items = { props.healthConditions }
                    addEditMemberHealthConfig={ searchAndAddHealthConditions }
                    notePlaceHolder ={  head( get( props, 'sections.healthConditions.others.fields', [] ) )[ 'placeholder' ]}
                    titleClassName = { 'ui-epost-allergies-and-health-conditions__health__title' }
                    showTitleIcon={ true }
                    noDataConfig = { healthNoDataConfig }
                    onUpdate={ props.onHealthConditionsUpdate }
                    className={ 'ui-epost-allergies-and-health-conditions__health__section' }
                    selectionCriteria={ 'name' }
                    healthVisibility = {props.visibility}
                    finalProp= { props }
                    titlehealth= { 'HealthCondition' }
                />
            </div>

            {/* actions */}
            <div className='ui-epost-allergies-and-health-conditions__actions'>
                { map( props.navActions, action => {
                    return(
                        <Button
                            className={  'ui-epost-allergies-and-health-conditions__actions__action' }
                            { ...action }
                            outline = { 'cancel' === action.name ? true : false }

                            // disabled = { 'cancel' !== action.name ? props.disableNextAction : false }
                            size='large'
                            key={ action.name }
                            onClick={ () => props.onNavActionClick( { action } ) }
                        />
                    );
                } ) }
            </div>
        </div>
    );
};

// set display name
_epostAllergiesAndHealthConditions.displayName = 'epostAllergiesAndHealthConditions';

// set default props
_epostAllergiesAndHealthConditions.defaultProps = {};

// prop types
_epostAllergiesAndHealthConditions.propTypes = {};


/******************************************************* */

const epostAllergiesAndHealthConditionsPreloader = ( ) => {
   
    return (
        <div className='ui-epost-allergies-and-health-conditions-preloader'>
         
            {
                map( [ 1, 2 ], _item => {
                    return (
                        <div key={ _item } className='ui-epost-allergies-and-health-conditions-preloader__form'>
                            <div className='ui-epost-allergies-and-health-conditions-preloader__form__title'></div>
                            {
                                map( [ 1, 2 ], item => {

                                    const className= classNames( 'ui-epost-allergies-and-health-conditions-preloader__form__search__section', {
                                        'ui-epost-allergies-and-health-conditions-preloader__form__search__section--small': 1 === item
                                    } );
                            
                                    return (
                                        <div key={ item } className={ 'ui-epost-allergies-and-health-conditions-preloader__form__search' }>
                                            <div className={ className }></div>
                                            {/* { 2 === item && (
                                                <div className='ui-epost-allergies-and-health-conditions-preloader__form__search__button'></div>
                                            ) } */}
                                        </div>
                                    );
                                } )
                            }
                        </div>
                    );
                } )
            }
            <div className='ui-epost-allergies-and-health-conditions-preloader__footer'>
                {
                    map( [ 1, 2 ], item => {
                        return (
                            <div key={ item } className='ui-epost-allergies-and-health-conditions-preloader__footer__actions'></div>
                        );
                    } )
                }
            </div>
            
        </div>
    );
};

/*****************************************/

const NoDataView = ( props ) => {

    const noData = head( props.fields );

    return  (
        <div className='ui-add-edit-allergies-no-data ui-add-editcheck' onClick={ () => props.onNoDataSelection() }>
            <CheckBox
                size='s'
                value={ props.isNoDataSelected }
            />
            <div className='ui-add-edit-allergies-no-data__label'>
                { getLabel( noData.title ) }
            </div>
        </div>
        
    );
};

// set display name
epostAllergiesAndHealthConditionsPreloader.displayName = 'epostAllergiesAndHealthConditionsPreloader';

// set default props
epostAllergiesAndHealthConditionsPreloader.defaultProps = {};

// prop types
epostAllergiesAndHealthConditionsPreloader.propTypes = {};

/******************************************************* */

export const epostAllergiesAndHealthConditions = withNetworkState( epostAllergiesAndHealthConditionsPreloader, _epostAllergiesAndHealthConditions );
